import { startCase } from "lodash"

export const createColumnGroupingModel = ({
  groupingEnabled,
  disableCategories,
  metricCategories,
  metricMetadata,
}) => {
  if (!groupingEnabled || disableCategories) {
    return undefined
  }

  const groupingModel = [
    { field: "label" },
  ]

  const categoryGroups = Object.entries(metricCategories)
    .filter(([categoryName]) => {
      // Only create groups for categories that have metrics
      const categoryMetrics = metricMetadata.filter(metric => metric.category === categoryName)
      return categoryMetrics.length > 0
    })
    .map(([categoryName, categoryInfo], index) => {
      const children = metricMetadata
        .filter(metric => metric.category === categoryName)
        .map(metric => ({ field: metric.id }))

      return {
        groupId: categoryName || `empty-${index}`,
        freeReordering: true,
        headerName: startCase(categoryInfo.label || categoryName || ""),
        headerClassName: "column-group-header",
        children,
      }
    })
    .filter(group => group.children.length > 0) // Ensure no empty groups

  groupingModel.push(...categoryGroups)

  return validateGroupingModel(groupingModel)
}

const validateGroupingModel = (groupingModel) => {
  return groupingModel.filter(item => {
    const isValid = (item.field && typeof item.field === "string")
      || (item.groupId && typeof item.groupId === "string" && item.children && Array.isArray(item.children))

    return isValid
  })
}
